import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContractProvider } from '../providers/contract.provider';
import { IdInterface, OrderClientInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransferProvider } from '../providers/transfer-provider.service';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface SignModelUseCaseParams {
    signatories: OrderClientInterface[];
    modelId: IdInterface;
}

@Injectable()
export class SignModelUseCase implements UseCaseWithParam<SignModelUseCaseParams, Observable<Transaction<boolean>>> {
    constructor(private contractProvider: ContractProvider, private transferProvider: TransferProvider) {}

    bind(params: SignModelUseCaseParams): Observable<Transaction<boolean>> {
        return this.contractProvider.current().pipe(
            switchMap((transaction) =>
                transaction.map(
                    (contract) => this.transferProvider.signModel(contract.encryptedCode, params.signatories, params.modelId),
                    (throwable) => of(Transaction.error(throwable.message))
                )
            )
        );
    }
}
